var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoUpcomingPosts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.33,
    y: 391.92,
    width: 31.57,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.93,
    y: 389.21,
    width: 33.41,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 401.21,
    width: 62.43,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 399.53,
    width: 19.23,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.6,
    y: 399.53,
    width: 30.29,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.58,
    y: 395.31,
    width: 54.56,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.45,255.24c-10.14-4.25-26.94-.15-40.86,16.73-6.43,7.8-12.63,19.24-14.3,30.95.11-13.36.25-27.71.38-41.26a76.35,76.35,0,0,1,7.19-19.06c10.21-20.52,18.65-18.25,32.52-34.31,23.07-26.72,36.29-77.13,13.34-57-20.81,18.2-30.88,36.42-37.87,52.23-9.46,21.37-13.26,36.28-15.11,51.24.13-12.72.25-24.4.36-33.41.36-29.39,1.16-38.84,1.31-41.76.36-7.07,2.69-11.19,3.34-12.2,5.47-8.59,14.06-14.21,22.47-24,19.61-22.79,30.93-51,21.48-53.66-9.87-2.73-22.84,9.71-37.25,38.92-8.26,16.74-10.37,20.7-12,53.5-.14,2.85-.77,13.59-1.07,28.51-2.33-16.05-6.76-32-14.49-42.57-14.91-20.39-26.25-22.34-34.51-20.39s-4.8,23.36,4.52,34.8c14,17.22,37.4,13.56,44.33,36.47-.35,20.23-.6,45.85-.74,69.71-2.36-12.32-4.83-22.57-10.25-32.22-10.08-17.94-22.48-25.77-31-17.32-5.31,5.26.85,20,11.95,26,11.27,6.14,20.52,14.63,24.1,19.74.83,1.19,3.6,5.75,5.18,8.38-.15,29.13-.13,54.84.12,63.61L401,357c-.09-2.26,0-17.08.12-36.69,2.46-24.47,19.74-25.8,30.79-30.46C451.66,281.5,466.59,259.5,456.45,255.24Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,382.4h29.14a3.25,3.25,0,0,0,3.28-2.23L420.5,344H380.66l2.06,36.14A3.26,3.26,0,0,0,386,382.4Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.39,356.33h38.38c.92,0,1.69-1.21,1.8-2.81l.78-12.2c.12-1.88-.72-3.52-1.79-3.52h-40c-1.08,0-1.92,1.64-1.79,3.52l.78,12.2C379.69,355.12,380.47,356.33,381.39,356.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.17,
    y: 304.47,
    width: 37.83,
    height: 71.31,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.44,
    y: 375.78,
    width: 186.57,
    height: 6.62,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.01,
    y: 304.47,
    width: 163.27,
    height: 71.31,
    transform: "translate(535.28 680.24) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.88,
    y: 313.14,
    width: 133.52,
    height: 21.94,
    transform: "translate(535.28 648.23) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.88,
    y: 341.33,
    width: 133.52,
    height: 21.94,
    transform: "translate(535.28 704.61) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.96,
    y: 310.42,
    width: 37.36,
    height: 4.7,
    rx: 2.3,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.96,
    y: 338.61,
    width: 37.36,
    height: 4.7,
    rx: 2.3,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.01,
    y: 298.07,
    width: 168.31,
    height: 6.39,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.89,
    y: 298.07,
    width: 43.12,
    height: 6.39,
    transform: "translate(328.89 602.54) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.84,326.48c-4.32-2.26-11.9-1.09-18.69,5.84a29.27,29.27,0,0,0-7.49,13.13c.55-5.89,1.16-12.23,1.73-18.21a34.07,34.07,0,0,1,3.9-8.15c5.29-8.68,8.94-7.36,15.67-13.93,11.22-10.93,19-32.71,8.07-24.7A62.83,62.83,0,0,0,96.31,302.1c-5,9.09-7.24,15.53-8.63,22.07.54-5.61,1-10.77,1.43-14.75,1.28-13,2-17.12,2.17-18.4a11.19,11.19,0,0,1,1.94-5.27C96,282.16,100,280,104.06,276c9.53-9.33,15.6-21.38,11.53-22.9-4.26-1.58-10.47,3.43-17.94,15.78-4.29,7.09-5.37,8.76-7.35,23.19-.18,1.26-.86,6-1.56,12.56-.42-7.18-1.77-14.39-4.79-19.36C78.14,275.69,73.2,274.4,69.48,275s-3,10.14.67,15.55c5.55,8.14,16,7.41,18.21,17.8-.92,8.92-2,20.24-3,30.78-.57-5.54-1.27-10.16-3.3-14.63-3.77-8.31-9-12.24-13-8.83-2.54,2.12-.38,8.86,4.3,12s8.51,7.24,9.9,9.64c.32.55,1.37,2.68,2,3.9C84,354,83.06,365.35,82.84,369.23l.65.09c.05-1,.64-7.54,1.45-16.2,2-10.73,9.7-10.66,14.76-12.3C108.73,337.9,116.16,328.74,111.84,326.48Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.94,304.2c5.59-2.52,15-.49,23,8.72a36.8,36.8,0,0,1,8.44,17c-.27-7.45-.55-15.45-.83-23a42.77,42.77,0,0,0-4.29-10.52c-6-11.29-10.68-9.9-18.65-18.65-13.27-14.56-21.4-42.47-8.29-31.61a79.24,79.24,0,0,1,21.9,28.56c5.59,11.78,7.93,20,9.19,28.35-.26-7.09-.51-13.6-.71-18.63-.63-16.38-1.22-21.64-1.35-23.27a14.26,14.26,0,0,0-2-6.75c-3.18-4.71-8-7.71-12.9-13.05-11.27-12.42-18-28-12.78-29.6,5.47-1.67,12.89,5.07,21.36,21.14,4.86,9.22,6.09,11.39,7.51,29.66.13,1.59.63,7.57,1,15.89,1.06-9,3.29-17.94,7.45-24,8-11.6,14.3-12.85,18.93-11.89s3,13-2,19.48c-7.56,9.81-20.65,8.11-24.17,21,.49,11.27,1,25.56,1.45,38.86,1.13-6.9,2.36-12.66,5.23-18.12,5.36-10.16,12.16-14.71,17-10.12,3,2.85-.17,11.16-6.28,14.7S82,316.9,80.08,319.8c-.45.67-1.92,3.26-2.76,4.75.52,16.24.89,30.58.88,35.47l-.83.07c0-1.26-.24-9.52-.62-20.46C75,326,65.36,325.54,59.13,323.11,48,318.77,39.35,306.72,44.94,304.2Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.59,382.4H94.44a2.91,2.91,0,0,0,2.92-2l1.83-32.06H63.84l1.84,32.06A2.89,2.89,0,0,0,68.59,382.4Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.49,359.28H98.54c.82,0,1.5-1.08,1.6-2.5l.69-10.82c.11-1.67-.63-3.12-1.59-3.12H63.8c-1,0-1.7,1.45-1.6,3.12l.7,10.82C63,358.2,63.68,359.28,64.49,359.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.19,
    y: 79.86,
    width: 213.04,
    height: 120.46,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.32,
    y: 79.86,
    width: 218.57,
    height: 120.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.69,
    y: 36.12,
    width: 109.83,
    height: 207.94,
    rx: 4.18,
    transform: "translate(310.69 -30.51) rotate(90)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-3",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M401.91,312.41h-24v-1h24a16,16,0,0,0,13.73-8.36l.88.48A17,17,0,0,1,401.91,312.41Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.33,
    y: 311.41,
    width: 9.83,
    height: 1,
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.91,308.91H121.11a10.85,10.85,0,0,1-11-12l15.17-174a13.4,13.4,0,0,1,13-12h280.8a10.86,10.86,0,0,1,11,12L415,296.91A13.4,13.4,0,0,1,401.91,308.91Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.06,305.26H122.26A9.24,9.24,0,0,1,112.94,295l13.82-158.51a3.28,3.28,0,0,1,3.19-2.94H418.32a2.65,2.65,0,0,1,2.68,2.94L407.17,295A11.41,11.41,0,0,1,396.06,305.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.16,125.66a13.32,13.32,0,0,1-13.47-14.75,16.44,16.44,0,0,1,16-14.75,13.31,13.31,0,0,1,13.46,14.75h-6a7.9,7.9,0,0,0-8-8.75,9.75,9.75,0,0,0-9.52,8.75,7.9,7.9,0,0,0,8,8.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.51,125.66A13.32,13.32,0,0,1,203,110.91a16.44,16.44,0,0,1,16-14.75,13.31,13.31,0,0,1,13.46,14.75h-6a7.9,7.9,0,0,0-8-8.75,9.75,9.75,0,0,0-9.52,8.75,7.91,7.91,0,0,0,8,8.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.86,125.66a13.32,13.32,0,0,1-13.46-14.75,16.42,16.42,0,0,1,16-14.75,13.31,13.31,0,0,1,13.46,14.75h-6a7.89,7.89,0,0,0-8-8.75,9.74,9.74,0,0,0-9.51,8.75,7.9,7.9,0,0,0,8,8.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.21,125.66a13.32,13.32,0,0,1-13.46-14.75,16.43,16.43,0,0,1,16-14.75,13.32,13.32,0,0,1,13.47,14.75h-6a7.9,7.9,0,0,0-8-8.75,9.74,9.74,0,0,0-9.51,8.75,7.9,7.9,0,0,0,8,8.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.56,125.66a13.32,13.32,0,0,1-13.46-14.75,16.43,16.43,0,0,1,16-14.75,13.32,13.32,0,0,1,13.47,14.75h-6a7.9,7.9,0,0,0-8-8.75,9.75,9.75,0,0,0-9.51,8.75,7.9,7.9,0,0,0,8,8.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.34,298.07H124.67a.44.44,0,0,1-.45-.5l13.49-154.66a.55.55,0,0,1,.54-.5H408.91a.45.45,0,0,1,.46.5L395.88,297.57A.55.55,0,0,1,395.34,298.07Zm-270.08-1H394.92l13.41-153.66H138.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,267.14H127.37a.45.45,0,0,1-.45-.5.54.54,0,0,1,.54-.5H398.12a.45.45,0,0,1,.46.5A.57.57,0,0,1,398,267.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.73,236.21H130.07a.46.46,0,0,1-.46-.5.56.56,0,0,1,.55-.5H400.82a.45.45,0,0,1,.46.5A.57.57,0,0,1,400.73,236.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.43,205.27H132.77a.45.45,0,0,1-.46-.5.57.57,0,0,1,.55-.5H403.52a.45.45,0,0,1,.45.5A.54.54,0,0,1,403.43,205.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.13,174.34H135.47a.45.45,0,0,1-.46-.5.55.55,0,0,1,.54-.5H406.22a.44.44,0,0,1,.45.5A.54.54,0,0,1,406.13,174.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.5,298.07a.44.44,0,0,1-.45-.5l13.49-154.66a.55.55,0,0,1,.54-.5.45.45,0,0,1,.46.5L362.05,297.57A.56.56,0,0,1,361.5,298.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.67,298.07a.45.45,0,0,1-.46-.5L340.7,142.91a.56.56,0,0,1,.55-.5.44.44,0,0,1,.45.5L328.21,297.57A.54.54,0,0,1,327.67,298.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.84,298.07a.45.45,0,0,1-.46-.5l13.49-154.66a.56.56,0,0,1,.55-.5.44.44,0,0,1,.45.5L294.38,297.57A.55.55,0,0,1,293.84,298.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,298.07a.45.45,0,0,1-.46-.5L273,142.91a.55.55,0,0,1,.54-.5.45.45,0,0,1,.46.5L260.55,297.57A.55.55,0,0,1,260,298.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.17,298.07a.44.44,0,0,1-.45-.5l13.49-154.66a.54.54,0,0,1,.54-.5.45.45,0,0,1,.46.5L226.72,297.57A.56.56,0,0,1,226.17,298.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.34,298.07a.45.45,0,0,1-.46-.5l13.49-154.66a.56.56,0,0,1,.55-.5.44.44,0,0,1,.45.5L192.88,297.57A.54.54,0,0,1,192.34,298.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.51,298.07a.45.45,0,0,1-.46-.5l13.49-154.66a.56.56,0,0,1,.55-.5.44.44,0,0,1,.45.5L159.05,297.57A.55.55,0,0,1,158.51,298.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.89 201.68 418.16 201.68 420.31 176.93 442.05 176.93 433.88 189.31 439.89 201.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.7,202.18H417.61l2.25-25.75H443l-8.49,12.88Zm-22-1h20.37l-5.77-11.87,7.84-11.88H420.77Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -103.80191, 31.288292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.44,232.61H339.77a2.88,2.88,0,0,1-2.92-3.19l1.6-18.36a3.56,3.56,0,0,1,3.48-3.19H362.6a2.89,2.89,0,0,1,2.92,3.19l-1.6,18.36A3.56,3.56,0,0,1,360.44,232.61Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.44,232.61H339.77a2.88,2.88,0,0,1-2.92-3.19l1.6-18.36a3.56,3.56,0,0,1,3.48-3.19H362.6a2.89,2.89,0,0,1,2.92,3.19l-1.6,18.36A3.56,3.56,0,0,1,360.44,232.61Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,227.1h-.08a.89.89,0,0,1-.74-.5,23.16,23.16,0,0,0-4.19-6.42,1,1,0,0,1,1.47-1.48,21.87,21.87,0,0,1,3.93,5.69,89.09,89.09,0,0,1,11.13-9.68,1,1,0,0,1,1.39.16,1,1,0,0,1-.28,1.41,84.89,84.89,0,0,0-11.83,10.47A1.09,1.09,0,0,1,348,227.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181.12,197.5c-8.34,0-15.29-2.95-20.22-8.6-6.33-7.27-7.28-16.29-2.49-23.55,7.11-10.75,25.64-16.48,37.83-14.89a.46.46,0,0,1,.39.56.56.56,0,0,1-.6.43c-11.89-1.55-29.91,4-36.79,14.4-5.42,8.2-2.29,16.92,2.45,22.36,6.61,7.58,15.62,8.65,22,8.2,12.19-.85,25.54-7.82,33.23-17.34,2.15-2.66,5.45-7.77,3.43-12-3-6.33-13-5.89-21.34-4.81a.46.46,0,0,1-.52-.43.55.55,0,0,1,.48-.56c5.58-.73,18.64-2.42,22.29,5.32,2.26,4.76-1.28,10.26-3.58,13.12-7.87,9.74-21.54,16.88-34,17.74C182.82,197.47,182,197.5,181.12,197.5Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.17,293.33a10.14,10.14,0,0,1-10.25-11.23,12.5,12.5,0,0,1,12.21-11.22,10.13,10.13,0,0,1,10.25,11.22A12.51,12.51,0,0,1,311.17,293.33ZM313,272.88a10.28,10.28,0,0,0-10,9.22,8.33,8.33,0,0,0,8.42,9.23,10.29,10.29,0,0,0,10-9.23A8.34,8.34,0,0,0,313,272.88Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,231.35a10.14,10.14,0,0,1-10.25-11.23A12.51,12.51,0,0,1,217,208.89a10.14,10.14,0,0,1,10.25,11.23A12.52,12.52,0,0,1,215,231.35Zm1.78-20.46a10.28,10.28,0,0,0-10,9.23,8.33,8.33,0,0,0,8.42,9.23,10.29,10.29,0,0,0,10-9.23A8.34,8.34,0,0,0,216.8,210.89Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3",
    transform: "matrix(1, 0, 0, 1, -12, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.54,258.24H130.64a6.78,6.78,0,0,1-6.84-7.5h0a8.37,8.37,0,0,1,8.15-7.5h103.9a6.78,6.78,0,0,1,6.84,7.5h0A8.37,8.37,0,0,1,234.54,258.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.39,234.41l3.9,1.67-5.23,6.41a22.13,22.13,0,0,1-2.12-5.06,2,2,0,0,1,1.45-2.49Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.08,243l-2.34,2.6a1.74,1.74,0,0,1-2.74-.19l-1.94-2.88,5.23-6.41,2.11,5A1.73,1.73,0,0,1,102.08,243Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.64,255.72,104.39,245a6.79,6.79,0,0,1-6.23-8h0a8.37,8.37,0,0,1,8.72-6.83l135.25,10.71a6.78,6.78,0,0,1,6.23,8h0A8.38,8.38,0,0,1,239.64,255.72Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.21,192.61c1.69,3.81,3.42,7.72,5.17,11.52s3.56,7.66,5.5,11a18.07,18.07,0,0,0,1.37,2c.6.71,1.27,1.44,1.95,2.19,1.39,1.49,2.88,3,4.37,4.48,3,3,6,6,9,9.13l-3,3.91a124,124,0,0,1-11-7.14c-1.78-1.29-3.52-2.63-5.26-4.09-.87-.73-1.73-1.51-2.61-2.36a24.55,24.55,0,0,1-2.51-3.09,100.37,100.37,0,0,1-6.73-11.72c-1.95-3.95-3.74-7.88-5.41-12Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.14,192c-2.27,3.71-4.6,7.44-6.93,11.13l-6.95,11.08-.85,1.38-.1.18,0,.08v0l0,.06a1.63,1.63,0,0,0-.13.24,7.93,7.93,0,0,0-.42,2.08,32.92,32.92,0,0,0,.17,5.8c.43,4.08,1.24,8.39,2.1,12.56l-4.64,1.72a65.25,65.25,0,0,1-5-12.88,33.85,33.85,0,0,1-1.17-7.33,16,16,0,0,1,.42-4.46c.14-.44.25-.84.44-1.31l.31-.68.13-.27.09-.18.77-1.51c2-4,4.21-7.88,6.44-11.72s4.55-7.61,7-11.35Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.6,164.31c-.18.49-.07,1,.25,1.14s.73-.16.92-.66.07-1-.25-1.14S137.79,163.81,137.6,164.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.48,165.3a20.06,20.06,0,0,0,.76,5.23,3,3,0,0,1-2.51-.53Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.43,161.39a.32.32,0,0,1-.17-.09,2.44,2.44,0,0,0-2.18-.47.31.31,0,0,1-.38-.23.31.31,0,0,1,.23-.37,3.05,3.05,0,0,1,2.76.62.31.31,0,0,1,0,.44A.31.31,0,0,1,139.43,161.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.37,165.29c-.63,5.38.4,12.16-3.28,14.86,0,0,.77,5,9.62,6.37,9.73,1.44,5.18-4.17,5.18-4.17-5.17-2.07-4.6-6-3.27-9.59Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,183.53c-.13-2.48,0-6.22,1.54-6.76,1.68-.59,11.61.2,16.59,4.71a15.74,15.74,0,0,0-1.7,7.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.57,406.57a6.86,6.86,0,0,1-2.58-.74.16.16,0,0,1-.09-.15.15.15,0,0,1,.1-.13c.09,0,2.09-.8,3-.37a.78.78,0,0,1,.41.48.63.63,0,0,1-.15.73A1,1,0,0,1,82.57,406.57Zm-2.11-.86c.92.41,2.23.73,2.58.44,0,0,.14-.11,0-.4a.48.48,0,0,0-.25-.29A4.21,4.21,0,0,0,80.46,405.71Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.06,405.85a.16.16,0,0,1-.11-.05.14.14,0,0,1,0-.15c0-.08.56-1.9,1.44-2.33a.83.83,0,0,1,.69,0,.51.51,0,0,1,.39.53c0,.75-1.61,1.83-2.33,2Zm1.68-2.31a.62.62,0,0,0-.26.06,3.65,3.65,0,0,0-1.17,1.84c.75-.34,1.78-1.19,1.81-1.64,0,0,0-.15-.19-.22A.46.46,0,0,0,81.74,403.54Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.84,409.48a11.09,11.09,0,0,1-2-.19.15.15,0,0,1,0-.28c.33-.2,3.25-1.87,3.95-.71a.6.6,0,0,1,0,.69C134.49,409.36,133.68,409.48,132.84,409.48Zm-1.53-.42c1.24.18,2.91.15,3.19-.25,0,0,.09-.13,0-.35C134.06,407.8,132.28,408.55,131.31,409.06Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.84,409.3a.11.11,0,0,1-.08,0,.15.15,0,0,1-.07-.14,4.3,4.3,0,0,1,.92-2.54,1.17,1.17,0,0,1,.86-.27c.44.05.57.27.6.45.12.76-1.37,2.15-2.16,2.51Zm1.51-2.67a.84.84,0,0,0-.54.2,3.53,3.53,0,0,0-.78,2c.79-.49,1.81-1.59,1.73-2.05,0,0,0-.16-.32-.19Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.61 409.14 130.19 409.14 130.26 393.89 123.67 393.89 123.61 409.14",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.61 404.42 78.78 405.85 83.96 390.77 77.79 389.34 72.61 404.42",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.74,404.83,72.57,403a.54.54,0,0,0-.64.3l-2.47,5.41a1,1,0,0,0,.69,1.38c2.52.59,3.77.75,6.92,1.54,1.94.49,5.9,1.7,8.58,2.37s3.59-1.92,2.54-2.43c-4.69-2.33-6.22-4.29-7.5-6.12A1.66,1.66,0,0,0,79.74,404.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.12,408.38h-7.19a.56.56,0,0,0-.55.45l-1.07,5.85a1,1,0,0,0,1,1.17c2.59,0,6.33-.19,9.59-.19,3.82,0,3.89.2,8.36.2,2.7,0,3.35-2.73,2.21-3-5.2-1.12-6.18-1.24-10.74-4A3.12,3.12,0,0,0,130.12,408.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.38,179.7c-6.26.5-15.09,16.2-15.09,16.2l11.34,10.27a100.54,100.54,0,0,0,9.61-12.64C118.69,186.4,114.78,179.19,108.38,179.7Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.38,179.7c-6.26.5-15.09,16.2-15.09,16.2l11.34,10.27a100.54,100.54,0,0,0,9.61-12.64C118.69,186.4,114.78,179.19,108.38,179.7Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.58,191l-7.49,14.66.53.49s2.9-3.17,6.13-7.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.75,214.9c-1.13,7.26-2.92,16.24-5.67,27.3L99.25,237c.32-5,5.65-27.29,4.6-51.22a5.82,5.82,0,0,1,5.94-6.09c1.72,0,3.61.13,5.47.31a132.4,132.4,0,0,1,14.81,2.2,67.16,67.16,0,0,1,9.82,3.31s2.5,3.67,1.15,18.94C140.77,207.48,140.36,210.93,139.75,214.9Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.75,214.9c-1.13,7.26-2.92,16.24-5.67,27.3L99.25,237c.32-5,5.65-27.29,4.6-51.22a5.82,5.82,0,0,1,5.94-6.09c1.72,0,3.61.13,5.47.31a132.4,132.4,0,0,1,14.81,2.2,67.16,67.16,0,0,1,9.82,3.31s2.5,3.67,1.15,18.94C140.77,207.48,140.36,210.93,139.75,214.9Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.75,214.9c-2.83-1.79-5.48-10-4.29-14.33l5.58,3.9C140.77,207.48,140.36,210.93,139.75,214.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.92,190c-1.8,6,9.1,23.67,9.1,23.67l13-6.8a73.81,73.81,0,0,0-7.64-15.76C141.17,183.44,134,183.22,131.92,190Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.92,190c-1.8,6,9.1,23.67,9.1,23.67l13-6.8a73.81,73.81,0,0,0-7.64-15.76C141.17,183.44,134,183.22,131.92,190Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.25 393.9 130.22 401.76 123.64 401.76 123.67 393.9 130.25 393.9",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.79 389.35 83.96 390.77 81.28 398.55 75.12 397.12 77.79 389.35",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.65,156.44c-1.91,6.27-3.34,9.83-1.46,14.23a8.49,8.49,0,0,0,15,1.42c3.34-5,5.9-14.38.91-19.27A8.58,8.58,0,0,0,121.65,156.44Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.72,163.33c-.75,3.21-2.7,9-7.5,9.67-2.68.37-7.14-.42-7.55-2.58s1.25-1.87.83-3.64-2.61-8-.12-12.36c-3.46.29-1.09-4.84,5.12-6-1.92-.75-1-6,8.58-3.5,4.48,1.15,7.81,2.91,8.21,5.32,4.08,1.72,5.16,6.05,2.63,7.63s-6.19-.2-6.19-.2S137.46,166.83,131.72,163.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.11,162.84a5.92,5.92,0,0,0,1.24,4c1.19,1.52,1.59,1.53,2.08-.16.45-1.52,1.54-4.92-.05-5.82S129.25,161.09,129.11,162.84Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.73,240.36S116.32,292,113,310.84c-3.7,20.64-28.28,87-28.28,87L73,394.94c6-23,14.89-65.83,20.3-82.23,4.08-24.93,0-56.27,6-75.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.45,394s-2.16,4.23-2.16,4.23l-13.16-3.31,1.09-4Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.39,260.5a2.89,2.89,0,0,1,1.13,0c-1.73,15.42-4.19,36-6.13,47.81C111.77,291.15,110.27,262.1,118.39,260.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.08,242.2s2.73,55.18,3.13,75.25c.41,20.88-4.59,82.79-4.59,82.79H121.46s-4.21-57.41-1.94-85.41c-2.69-21.33-8.33-76-8.33-76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.35,232.3a12.13,12.13,0,0,0-5.34.76l-.81,1.34a2.05,2.05,0,0,0,1.14,3l3.91,1.25,1.91.58a2,2,0,0,0,2.22-.75l.82-1.14a2,2,0,0,0-.29-2.68l-1.76-1.59A3.11,3.11,0,0,0,174.35,232.3Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.59,395.79s-.45,4.63-.45,4.63H120.57l-.52-4.13Z",
    style: {
      fill: "#00AB65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 354.915 255.701 C 346.575 255.701 339.625 252.751 334.695 247.101 C 328.365 239.831 327.415 230.811 332.205 223.551 C 339.315 212.801 357.845 207.071 370.035 208.661 C 370.305 208.696 370.486 208.956 370.425 209.221 C 370.361 209.495 370.104 209.678 369.825 209.651 C 357.935 208.101 339.915 213.651 333.035 224.051 C 327.615 232.251 330.745 240.971 335.485 246.411 C 342.095 253.991 351.105 255.061 357.485 254.611 C 369.675 253.761 383.025 246.791 390.715 237.271 C 392.865 234.611 396.165 229.501 394.145 225.271 C 391.145 218.941 381.145 219.381 372.805 220.461 C 372.539 220.496 372.3 220.298 372.285 220.031 C 372.277 219.749 372.485 219.507 372.765 219.471 C 378.345 218.741 391.405 217.051 395.055 224.791 C 397.315 229.551 393.775 235.051 391.475 237.911 C 383.605 247.651 369.935 254.791 357.475 255.651 C 356.615 255.671 355.795 255.701 354.915 255.701 Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 389.889 170.003 C 383.79 170.105 378.983 164.838 379.639 158.773 C 380.287 152.467 385.55 147.642 391.889 147.543 C 397.988 147.442 402.796 152.709 402.139 158.773 C 401.487 165.078 396.226 169.9 389.889 170.003 Z M 391.669 149.543 C 386.485 149.658 382.198 153.615 381.669 158.773 C 381.127 163.757 385.077 168.087 390.089 168.003 C 395.272 167.885 399.557 163.93 400.089 158.773 C 400.623 153.8 396.691 149.479 391.689 149.543 L 391.669 149.543 Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(0, 171, 101)",
      fontFamily: "'Segoe UI'",
      fontSize: 28,
      fontWeight: 700,
      whiteSpace: "pre"
    },
    x: 122.398,
    y: 468.806
  }, "No Upcoming Posts"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUpcomingPosts);
export default __webpack_public_path__ + "static/media/no-upcoming-posts.133b6a246d796c2b07cd191089ce9975.svg";
export { ForwardRef as ReactComponent };